// Sculk sensor (M22.1 deep dark). PURE (ENG-1). A sculk sensor "hears" a vibration
// within range and emits redstone power while active; a calibrated sensor only
// reacts to a vibration whose frequency matches the redstone signal on its side
// input. Keeping the vibration-frequency table here makes it a unit test rather
// than an in-world experiment (like the other redstone sensors in sensors.ts).
import { SCULK_SENSOR } from '../config';

/** A vibration within range wakes a sculk sensor. */
export function sculkDetects(dist: number): boolean {
  return dist <= SCULK_SENSOR.VIBRATION_RANGE;
}

/** Game-event → vibration frequency (1..15) — the value a calibrated sensor filters
 *  on. A faithful subset of Java's game-event frequency table. */
const FREQUENCY: Record<string, number> = {
  step: 1, swim: 1, land: 2, splash: 3, hit: 4,
  projectile_land: 5, eat: 8, block_place: 9, block_destroy: 11,
  explode: 13, lightning: 14, instrument: 15,
};
export function vibrationFrequency(event: string): number {
  return FREQUENCY[event] ?? 0;
}

/** Ticks a sculk sensor stays active (powered) after a vibration. */
export function sculkActiveTicks(): number {
  return SCULK_SENSOR.ACTIVE_TICKS;
}

/** Redstone power an active sensor emits (full while active, 0 otherwise). */
export function sculkPower(active: boolean): number {
  return active ? SCULK_SENSOR.POWER : 0;
}

/** A calibrated sculk sensor only reacts to a vibration whose frequency matches its
 *  side-input redstone signal (0 = uncalibrated → accept any frequency). */
export function calibratedAccepts(freq: number, sideInput: number): boolean {
  return sideInput === 0 || freq === sideInput;
}
